import { useEffect, useState } from 'react';

export function useVerticalOffset(ids: string[]) {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        if (!ids || ids.length === 0) return;

        const elements = ids
            .map(id => document.getElementById(id))
            .filter(el => el !== null);

        if (elements.length === 0) return;

        const updateHeight = () => {
            const totalHeights = elements.reduce((sum, el) => {
                return (sum += el?.offsetHeight || 0);
            }, 0);
            setOffset(totalHeights);
        };

        updateHeight();
    }, [ids]);

    return offset;
}
